import type React from 'react'

import { Link } from 'react-router-dom'

import NewArrival from './NewArrival'
import ProductPrice from './ProductPrice'

interface ProductInfoProps {
  isNewArrival: boolean
  name: string
  price: number
  regularPrice: number
  salePrice: number
  url: string
}

export const ProductInfo: React.FC<ProductInfoProps> = ({
  isNewArrival,
  name,
  price,
  regularPrice,
  salePrice,
  url,
}) => (
  <>
    {isNewArrival && <NewArrival />}
    <Link to={url}>
      <h1 className="product_title entry-title mb-4 text-xl font-medium uppercase md:text-2xl">
        {name}
      </h1>
    </Link>
    <div className="text-xl font-medium">
      <ProductPrice
        price={price}
        regularPrice={regularPrice}
        salePrice={salePrice}
      />
    </div>
  </>
)
